import { useQuery } from '@tanstack/react-query'

import api from '../../api'
import type { gcpProject, gcpProjectIndexItem } from '../../types/gcpProject'

export type ApprovedGcpProjectWithTags = gcpProject & gcpProjectIndexItem

export const getApprovedGcpProjectsWithTags = async (): Promise<
	Array<ApprovedGcpProjectWithTags>
> => {
	const response = await api.gcpProjects.getgcpProjects(true)
	const approvedProjects = (response.body ?? []) as Array<gcpProjectIndexItem>

	return Promise.all(
		approvedProjects.map(async (project) => {
			const fullProjectResponse = await api.gcpProjects.getSinglegcpProject(
				project.gcpProjectID,
				true
			)
			const fullProject = fullProjectResponse.body?.[0] as
				| gcpProject
				| undefined

			return {
				...project,
				...(fullProject ?? {})
			} as ApprovedGcpProjectWithTags
		})
	)
}

const useApprovedGcpProjectsWithTags = () => {
	return useQuery({
		queryKey: ['approvedGcpProjects', 'withTags'],
		queryFn: getApprovedGcpProjectsWithTags
	})
}

export default useApprovedGcpProjectsWithTags
